import React, { useState } from "react";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import RoundedDropdown from "../../Component/BasicComponents/Dropdowns/RoundedDropdown";
import { useNavigate } from "react-router-dom";
// import AnnouncementModal from "./components/AnnouncementModal";

type Props = {};

function ESSOverview({}: Props) {
  const navigate = useNavigate();
  const [isOpenModal, setIsModalOpen] = useState(false);
  const [modalStatus, setModalStatus] = useState("");

  const handleSubmittedClick = () => {
    navigate("/essoverviewsummary");
    // setIsModalOpen(true);
  };

  const handleLeaveRequestView = () => {
    setModalStatus("View");
    setIsModalOpen(true);
  };

  // const handleAddAnnouncements = () => {
  //   setModalStatus("Add");
  //   setIsModalOpen(true);
  // };

  return (
    <div className="p-2">
      <PageHeader
        title="ESS Overview"
        buttons={[
          // {
          //   label: "+ Add Announcements",
          //   onClick: () => handleAddAnnouncements(),
          //   color: "#43B9B2",
          // },
          {
            label: "Excel",
            onClick: () => alert("Download Excel"),
            color: "#43B9B2",
          },
          {
            label: "CSV",
            onClick: () => alert("Download CSV"),
            color: "#43B9B2",
          },
        ]}
      />

      {/* Table with Filters */}
      <BasicDataTable
        Title="Admin Report"
        data={announcementData || []}
        columns={leaveRequestColumns(handleSubmittedClick)}
        headerContent={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "10px",
              marginBottom: "15px",
            }}
          >
            {/* Month Dropdown */}
            <RoundedDropdown
              options={[]}
              onSelect={(e) => console.log("status", e)}
              defaultLabel="All"
              width="120px"
              isShowHeading
              DropdownHeading="Division"
              headingColor="#2e8dd3"
            />
            <RoundedDropdown
              options={[]}
              onSelect={(e) => console.log("status", e)}
              defaultLabel="All"
              width="120px"
              isShowHeading
              DropdownHeading="Month"
              headingColor="#2e8dd3"
            />
          </div>
        }
        // onChangePage={(pageNo: number) => {
        //   handlePagination(pageNo);
        // }}
        // onChangeRowsPerPage={(newPerPage: any, page: any) => {
        //   handleonChangeRowsPerPage(newPerPage, page);
        // }}
        // handleSearch={(val: any) => {
        //   handleSearch(val);
        // }}
        // paginationTotalRows={
        //   leaveRequestDataa?.data?.pagination?.total_records || 0
        // }
        // showheaderContent={true}
      />
    </div>
  );
}

export default ESSOverview;

const leaveRequestColumns = (handleSubmittedClick: (row: any) => void) => [
  {
    name: "Employee Name",
    selector: (row: { employeename: string }) =>
      row.employeename ? row.employeename : "-",
    sortable: true,
    // width: "180px",
  },
  {
    name: "Designation",
    selector: (row: { designation: string }) => row.designation ?? "-",
    sortable: true,
    // width: "180px",
  },
  {
    name: "Head Quarter Location",
    selector: (row: { HQL: string }) => row.HQL ?? "-",
    sortable: true,
    // width: "150px",
  },
  {
    name: "Created",
    selector: (row: { created: string }) => row.created || "-",
    sortable: true,
    // width: "150px",
  },
  {
    name: "Submitted",
    selector: (row: { submitted: string }) => row.submitted || "-",
    sortable: true,
    cell: (row: any) => (
      <span
        style={{
          color: "#007BFF",
          cursor: "pointer",
          // textDecoration: "underline",
        }}
        onClick={() => handleSubmittedClick(row)}
      >
        {row.submitted || "-"}
      </span>
    ),
    // width: "150px",
  },
  {
    name: "Approved",
    selector: (row: { approved: string }) => row.approved || "-",
    sortable: true,
    // width: "150px",
  },
  {
    name: "Rejected",
    selector: (row: { rejected: string }) => row.rejected || "-",
    sortable: true,
    // width: "150px",
  },
  {
    name: "Processed",
    selector: (row: { processed: string }) => row.processed || "-",
    sortable: true,
    // width: "150px",
  },
];

const announcementData = [
  {
    employeename: "Test Sample",
    designation: "Test Sample",
    HQL: "Test Sample",
    created: "0",
    submitted: "0",
    approved: "0",
    rejected: "0",
    processed: "0",
  },
  {
    employeename: "Test Sample",
    designation: "Test Sample",
    HQL: "Test Sample",
    created: "0",
    submitted: "0",
    approved: "0",
    rejected: "0",
    processed: "0",
  },
  {
    employeename: "Test Sample",
    designation: "Test Sample",
    HQL: "Test Sample",
    created: "0",
    submitted: "0",
    approved: "0",
    rejected: "0",
    processed: "0",
  },
  {
    employeename: "Test Sample",
    designation: "Test Sample",
    HQL: "Test Sample",
    created: "0",
    submitted: "0",
    approved: "0",
    rejected: "0",
    processed: "0",
  },
  {
    employeename: "Test Sample",
    designation: "Test Sample",
    HQL: "Test Sample",
    created: "0",
    submitted: "0",
    approved: "0",
    rejected: "0",
    processed: "0",
  },
  {
    employeename: "Test Sample",
    designation: "Test Sample",
    HQL: "Test Sample",
    created: "0",
    submitted: "0",
    approved: "0",
    rejected: "0",
    processed: "0",
  },
];
